module.exports = __webpack_public_path__ + "static/media/default-order.df8fce65.png";